import { Link } from 'react-router-dom';
import { comics, featuredComicIds } from '@/mocks/comics';
import ComicCard from './ComicCard';

export default function FeaturedSection() {
  const featured = featuredComicIds.map((id) => comics.find((c) => c.id === id)!);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">热门推荐</h2>
            <p className="text-sm text-foreground-500 mt-2">编辑精选，口碑爆棚的漫画作品</p>
          </div>
          <Link
            to="/category/all"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {featured.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}